import { Sparkles } from "lucide-react";

export const TIERS = [
  { name: "Black",  min: 1000, next: null, from: "from-gray-900",   to: "to-gray-700",   bar: "bg-yellow-400" },
  { name: "Gold",   min: 500,  next: 1000, from: "from-yellow-500", to: "to-amber-400",  bar: "bg-white" },
  { name: "Silver", min: 200,  next: 500,  from: "from-slate-400",  to: "to-slate-600",  bar: "bg-white" },
  { name: "Bronze", min: 0,    next: 200,  from: "from-amber-700",  to: "to-orange-500", bar: "bg-white" },
];

export const TIER_BADGE_CLASS = {
  Black:  "bg-gray-900 text-white border-gray-700",
  Gold:   "bg-yellow-400 text-yellow-900 border-yellow-300",
  Silver: "bg-gray-200 text-gray-700 border-gray-300",
  Bronze: "bg-amber-100 text-amber-800 border-amber-200",
};

export function getVipTier(spent = 0) {
  return TIERS.find(t => spent >= t.min) || TIERS[3];
}

export function PortalLoyaltyCard({ customer }) {
  const spent    = customer?.total_spent     || 0;
  const cashback = customer?.cashback_balance || 0;
  const points   = customer?.points           || 0;
  const tier     = getVipTier(spent);

  const pct       = tier.next ? Math.min(100, ((spent - tier.min) / (tier.next - tier.min)) * 100) : 100;
  const remaining = tier.next ? Math.max(0, tier.next - spent) : 0;
  const nextName  = tier.next ? TIERS.find(t => t.min === tier.next)?.name : null;

  return (
    <div className={`rounded-2xl bg-gradient-to-br ${tier.from} ${tier.to} text-white p-6 shadow-xl`}>
      <div className="flex items-start justify-between mb-4">
        <div>
          <p className="text-white/60 text-[10px] uppercase tracking-widest font-semibold mb-0.5">Nível</p>
          <div className="flex items-center gap-2">
            <span className="text-3xl font-black tracking-tight">{tier.name}</span>
            <Sparkles className="w-5 h-5 text-white/50" />
          </div>
        </div>
        {cashback > 0 ? (
          <div className="text-right">
            <p className="text-white/60 text-[10px] uppercase tracking-wide">Disponível</p>
            <p className="text-2xl font-black">€{cashback.toFixed(2)}</p>
          </div>
        ) : points > 0 ? (
          <div className="text-right">
            <p className="text-white/60 text-[10px] uppercase tracking-wide">Pontos</p>
            <p className="text-2xl font-black">{points.toLocaleString()}</p>
          </div>
        ) : null}
      </div>

      {tier.next ? (
        <>
          <div className="flex justify-between items-center mb-1.5">
            <span className="text-white/70 text-xs">Progresso para {nextName}</span>
            <span className="text-white/70 text-xs">€{Math.round(spent)} / €{tier.next}</span>
          </div>
          <div className="h-2.5 rounded-full bg-white/20 overflow-hidden">
            <div className={`h-full rounded-full ${tier.bar} transition-all duration-700`} style={{ width: `${pct}%` }} />
          </div>
          {remaining > 0 && (
            <p className="text-white/60 text-[11px] mt-1.5">
              Faltam <span className="text-white font-semibold">€{Math.ceil(remaining)}</span> para subir de nível
            </p>
          )}
        </>
      ) : (
        <p className="text-white/70 text-sm mt-2">🏆 Nível máximo atingido. Obrigado pela fidelidade!</p>
      )}
    </div>
  );
}
